import { get, post, put, destroy } from './base';
export const PDTServe = {
    index: (params) =>
        get('/predefinedtemplates',{params:params}),
    single: (id) =>
        get(`/predefinedtemplates/${id}`),
    singleByEmail: (email) =>
        get(`/predefinedtemplates?email=${email}`),
    create: (payload) =>
        post('/predefinedtemplates', payload),
    update: (id, payload) =>
        put(`/predefinedtemplates/${id}`, payload),
    remove: (id) =>
        destroy(`/predefinedtemplates/${id}`),
}